import { render, staticRenderFns } from "./addComplaintTypeList.vue?vue&type=template&id=2d8da680&scoped=true"
import script from "./addComplaintTypeList.vue?vue&type=script&lang=js"
export * from "./addComplaintTypeList.vue?vue&type=script&lang=js"
import style0 from "./addComplaintTypeList.vue?vue&type=style&index=0&id=2d8da680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8da680",
  null
  
)

export default component.exports